document.addEventListener('change', (event) => {
  const select = event.target;
  if (!select.matches('.cart-drawer-item__selling-plan-select')) return;

  event.stopPropagation();

  const line = select.dataset.index;
  const cartItems = document.querySelector('cart-drawer-items');
  if (!cartItems || typeof cartItems.updateSellingPlan !== 'function') return;

  select.setAttribute('data-last-value', select.value);
  const sellingPlanId = select.value ? parseInt(select.value, 10) : null;
  cartItems.updateSellingPlan(line, sellingPlanId, event);
});
